import moment from 'moment';
import {
  getCampaignsOverviewData,
  getCustomersOverviewData,
  getCouponsOverviewData,
} from '../services/AnalyticsApiHelper';
import { apiWithResponseHandle } from './LoadingUtil';
import { createAction } from '../utils';
import { parseCustomerChartData } from './DashboardModel';

const parseCampaignsApiData = (resp) => {
  const { analyticsData } = resp;
  return {
    totalPublishedCampaign: analyticsData.totalNumberOfPublishedCampaigns,
    totalCampaignConversion: analyticsData.totalNumberOfCampaignConversions,
    totalCampaignViews: analyticsData.totalNumberOfCampaignViews,
    couponCampaignConversionRate: analyticsData.couponCampaignConversionRate,
    earningCampaignConversionRate: analyticsData.earningCampaignConversionRate,
    campaignShareRate: analyticsData.campaignShareRate,

    totalPointsEarned: analyticsData.totalPointsEarned,
    totalPointsUsed: analyticsData.totalPointsUsed,

    totalCouponActivities: analyticsData.totalNumberOfCouponActivities,
    totalCouponRedeemByPoints:
      analyticsData.totalNumberOfCouponsRedeemedByPoints,
    totalCouponUsed: analyticsData.totalNumberOfCouponsUsed,
    totalCouponAcquiredByCampaigns:
      analyticsData.totalNumberOfCouponsAcquiredByCampaigns,
  };
};

const parseCustomersApiData = (resp) => {
  const { analyticsData } = resp;
  return {
    totalCustomers: {
      ...analyticsData.totalNumberOfCustomers,
    },
    activeCustomers: {
      ...analyticsData.totalNumberOfActiveCustomers,
    },
    newCustomers: {
      ...analyticsData.totalNumberOfNewCustomers,
    },
    nonRegistedCustomers: {
      ...analyticsData.totalNumberOfGuestCustomers,
    },
    chartData: parseCustomerChartData(
      analyticsData.totalNumberOfNewCustomersChart,
    ),
  };
};

const parseCouponsApiData = (resp) => {
  const { analyticsData } = resp;
  return {
    totalCouponActivities: analyticsData.totalNumberOfCouponActivities,
    totalCouponRedeemByPoints:
      analyticsData.totalNumberOfCouponsRedeemedByPoints,
    totalCouponUsed: analyticsData.totalNumberOfCouponsUsed,
    totalCouponAcquiredByCampaigns:
      analyticsData.totalNumberOfCouponsAcquiredByCampaigns,
  };
};

export default {
  namespace: 'overview',
  state: {
    customers: {},
    coupons: {},
    campaigns: {},
  },
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clearState(state, { payload }) {
      return {
        customers: {},
        coupons: {},
        campaigns: {},
      };
    },
  },
  effects: {
    getCampaignsData: [
      function* ({ payload }, { put }) {
        const { startDate, endDate } = payload;
        const serviceArgs = [getCampaignsOverviewData, startDate, endDate];
        function* onSuccess(data) {
          const processedData = parseCampaignsApiData(data);
          yield put(createAction('updateState')({ campaigns: processedData }));
        }
        function* onFailed(data) {
          console.log('@Get campaigns overview data failed: ', data);
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess, onFailed);
      },
      { type: 'takeLatest' },
    ],
    getCustomersData: [
      function* ({ payload }, { put }) {
        const { startDate, endDate } = payload;
        const serviceArgs = [getCustomersOverviewData, startDate, endDate];
        function* onSuccess(data) {
          const processedData = parseCustomersApiData(data);
          yield put(createAction('updateState')({ customers: processedData }));
        }
        function* onFailed(data) {
          console.log('@Get customers overview data failed: ', data);
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess, onFailed);
      },
      { type: 'takeLatest' },
    ],
    getCouponsData: [
      function* ({ payload }, { put }) {
        const { startDate, endDate } = payload;
        const serviceArgs = [getCouponsOverviewData, startDate, endDate];
        function* onSuccess(data) {
          const processedData = parseCouponsApiData(data);
          yield put(createAction('updateState')({ coupons: processedData }));
        }
        function* onFailed(data) {
          console.log('@Get coupons overview data failed: ', data);
        }
        yield apiWithResponseHandle(serviceArgs, onSuccess, onFailed);
      },
      { type: 'takeLatest' },
    ],
  },
};
